// ImageHover.jsx
import React, { useState } from 'react';

const ImageHover = ({ title, primarySrc, secondarySrc, altText }) => {
    const [currentSrc, setCurrentSrc] = useState(primarySrc);

    const handleMouseEnter = () => {
        setCurrentSrc(secondarySrc);
    };

    const handleMouseLeave = () => {
        setCurrentSrc(primarySrc);
    };

    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {primarySrc && (
                <img
                    src={currentSrc}
                    alt={altText}
                    style={{ width: '16px', height: '16px', margin: '0 3px' }}
                />)}
            {title}
        </div>
    );
};

export default ImageHover;
